import CareOfYourPrivacy from './HowWeTakeCareOfYourPrivacy';
import TandC from './TermsAndConditions';

export const HowWeTakeCareOfYourPrivacy = CareOfYourPrivacy;
export const TermsAndConditions = TandC;